import React,{useEffect, useState} from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import Environment from '../../../environment/Environment';


interface Props {
  isOpen: boolean;
  toggle: () => void;
  docUrl: string;   // secured endpoint for OLH
}

interface State {
  helpHtml: string;
}


export default class HelpModal extends React.PureComponent<Props, State> {
  
  iframeRef: React.RefObject<HTMLIFrameElement>;

  constructor(props) {
    super(props);
    this.iframeRef = React.createRef();

    this.state = {
      helpHtml: '', // <-- Add this
    };
  }
  

  render(): React.ReactNode {
    return (
      <Modal
        isOpen={this.props.isOpen}
        toggle={this.props.toggle}
        centered
        className="custom-help-modal"
        size="xl"
      >
        <ModalBody style={{ height: "80vh", padding: 0 }}>
          <iframe
            ref={this.iframeRef}
            src={`${Environment.API}/${this.props.docUrl}`}
            title="Help Document"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.props.toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}


